module.exports = __webpack_public_path__ + "static/media/poweredbyhome.ec03865b.png";